// extracted by mini-css-extract-plugin
export var offerRoomClosed = "Timer-module--offer-room-closed--mC8u6";
export var primary = "#06004d";
export var secondary = "#4dafd7";
export var timeRemaining = "Timer-module--time-remaining--Q0al5";